/** Strings of the work-item list (and the shared widgets it uses): `en` is the source, `cs` must have the same keys. */
export const workItemListEn = {
  workItemList: {
    count_one: "{{count}} work item",
    count_other: "{{count}} work items",
    count_few: "{{count}} work items",
    exportCsv: "Export CSV",
    exportPdf: "Export PDF",
    searchPlaceholder: "Search work items...",
    unnamed: "(unnamed)",
    empty: "No work items found.",
    selectRow: "Select work item {{id}}",
    attachments_one: "{{count}} attachment",
    attachments_other: "{{count}} attachments",
    attachments_few: "{{count}} attachments",
    hours: "{{value}}h",
    columns: {
      type: "Type",
      status: "Status",
      priority: "Pri",
      title: "Title",
      project: "Project",
      release: "Release",
      logged: "Logged",
      billing: "Billing",
      assignee: "Assignee",
      due: "Due",
      created: "Created",
      lastUpdate: "Last update",
      actions: "Actions",
    },
    billingFixed: "Fixed price",
    billingHours: "By hours",
    quick: {
      open: "Open",
      mine: "Mine",
      reportedByMe: "Reported by me",
      bugs: "Bugs",
      hotfixes: "Hotfixes",
      highPriority: "High Priority",
      dueThisWeek: "Due this week",
      reset: "All · reset",
      resetTitle: "Clear every filter",
    },
    filter: {
      status: "Filter by status",
      allStatuses: "All statuses",
      priority: "Filter by priority",
      allPriorities: "All priorities",
      type: "Filter by type",
      allTypes: "All types",
      assignee: "Filter by assignee",
      allAssignees: "All assignees",
      noUsers: "No users",
      unassigned: "Unassigned",
      reporter: "Filter by reporter",
      allReporters: "All reporters",
      watcher: "Filter by watcher",
      allWatchers: "All watchers",
      project: "Filter by project",
      allProjects: "All projects",
      noProjects: "No projects",
      environment: "Filter by environment",
      allEnvironments: "All environments",
      onDev: "On dev",
      onTest: "On test",
      onProduction: "On production",
      notDeployed: "Not deployed",
      release: "Filter by release",
      allReleases: "All releases",
      noRelease: "No release",
      scope: "Filter by scope",
      defaultScope: "Default scope",
      openOnly: "Open only",
      includeClosed: "Include closed",
      attachments: "Filter by attachments",
      anyAttachments: "Any attachments",
      withAttachments: "With attachments",
    },
    similar: {
      one: "A similar work item already exists",
      other: "{{count}} similar work items already exist",
    },
    dialog: {
      title: "New {{type}}",
      project: "Project",
      selectProject: "— select project —",
      noProjects: "No projects",
      initialState: "Initial state",
      stateNew: "New (default)",
      stateEstimation: "Estimation (requires assignee)",
      stateApproving: "Approving (requires estimate)",
      priority: "Priority",
      assignee: "Assignee",
      pickProject: "Pick a project…",
      loading: "Loading…",
      defaultTeam: "— default team (Metoděj develops) —",
      noMembers: "No project members",
      targetRelease: "Target release",
      none: "— none —",
      noReleases: "No releases",
      titleLabel: "Title",
      titlePlaceholder: "{{type}} title",
      description: "Description",
      descriptionPlaceholder: "Describe the {{type}}…",
      estimatedHours: "Estimated hours",
      dueDate: "Due date",
      cancel: "Cancel",
      saveAndOpen: "Save & open detail",
      save: "Save",
      pickProjectFirst: "Pick a project first",
      titleRequired: "Title is required",
      created: "{{type}} created",
      createFailed: "Failed to create work item",
      requestFailed: "Request failed",
    },
    newButton: "New {{type}}",
  },
  workItemLabels: {
    type: {
      feature: "Feature",
      bug: "Bug",
      task: "Task",
      hotfix: "Hotfix",
    },
    typeBadge: {
      feature: "FEATURE",
      bug: "BUG",
      task: "TASK",
      hotfix: "HOTFIX",
    },
    priority: {
      low: "Low",
      normal: "Normal",
      high: "High",
      urgent: "Urgent",
    },
    state: {
      new: "new",
      estimation: "estimation",
      approving: "approving",
      in_progress: "in progress",
      client_review: "client review",
      done: "done",
      blocked: "blocked",
      waiting_on_client: "waiting on client",
      cancelled: "cancelled",
      triage: "triage",
      waiting_on_dependency: "waiting on another ticket",
      spec_drafting: "creating specification",
      spec_client_review: "specification approval",
      merge_to_dev: "merge into dev",
      merge_to_test: "merge into test",
      merge_to_main: "merge into production",
      internal_test_dev: "internal testing on dev",
      client_test_dev: "client testing on dev",
      internal_test_test: "internal testing on test",
      client_test_test: "client testing on test",
      internal_test_main: "internal testing on production",
      client_test_main: "client testing on production",
      dev_review: "deploying to dev",
      ready_for_test: "deploying to test",
      testing_on_test: "testing on test",
      release_queue: "in release queue",
    },
    releaseStatus: {
      open: "open",
      locked: "locked",
      closed: "closed",
    },
  },
  ui: {
    close: "Close",
    clear: "Clear",
    clearSelection: "Clear selection",
    search: "Search…",
    loading: "Loading…",
    noMatches: "No matches",
    selectPlaceholder: "— select —",
    selectAll: "Select all",
    noRecords: "No records yet.",
    previousMonth: "Previous month",
    nextMonth: "Next month",
    openCalendar: "Open calendar",
    dateRange: {
      allTime: "All time",
      previous: "Previous period",
      next: "Next period",
      presets: {
        today: "Today",
        yesterday: "Yesterday",
        thisWeek: "This week",
        lastWeek: "Last week",
        pastTwoWeeks: "Past two weeks",
        thisMonth: "This month",
        lastMonth: "Last month",
        thisYear: "This year",
        lastYear: "Last year",
      },
    },
    time: "Time",
    timeHhmm: "Time (hh:mm)",
    rowsPerPage: "Rows per page",
    rows: "Rows",
    previousPage: "Previous page",
    nextPage: "Next page",
    page: "Page {{page}}",
    showing: "Showing <1>{{from}}–{{to}}</1> of <1>{{total}}</1>",
  },
};
export const workItemListCs: typeof workItemListEn = {
  workItemList: {
    count_one: "{{count}} tiket",
    count_other: "{{count}} tiketů",
    count_few: "{{count}} tikety",
    exportCsv: "Export CSV",
    exportPdf: "Export PDF",
    searchPlaceholder: "Hledat tikety...",
    unnamed: "(bez jména)",
    empty: "Žádné tikety nenalezeny.",
    selectRow: "Vybrat tiket {{id}}",
    attachments_one: "{{count}} příloha",
    attachments_other: "{{count}} příloh",
    attachments_few: "{{count}} přílohy",
    hours: "{{value}} h",
    columns: {
      type: "Typ",
      status: "Stav",
      priority: "Prio",
      title: "Název",
      project: "Projekt",
      release: "Release",
      logged: "Odpracováno",
      billing: "Fakturace",
      assignee: "Řešitel",
      due: "Termín",
      created: "Vytvořeno",
      lastUpdate: "Poslední změna",
      actions: "Akce",
    },
    billingFixed: "Pevná cena",
    billingHours: "Podle hodin",
    quick: {
      open: "Otevřené",
      mine: "Moje",
      reportedByMe: "Zadané mnou",
      bugs: "Chyby",
      hotfixes: "Hotfixy",
      highPriority: "Vysoká priorita",
      dueThisWeek: "Termín tento týden",
      reset: "Vše · zrušit filtry",
      resetTitle: "Zrušit všechny filtry",
    },
    filter: {
      status: "Filtrovat podle stavu",
      allStatuses: "Všechny stavy",
      priority: "Filtrovat podle priority",
      allPriorities: "Všechny priority",
      type: "Filtrovat podle typu",
      allTypes: "Všechny typy",
      assignee: "Filtrovat podle řešitele",
      allAssignees: "Všichni řešitelé",
      noUsers: "Žádní uživatelé",
      unassigned: "Nepřiřazeno",
      reporter: "Filtrovat podle zadavatele",
      allReporters: "Všichni zadavatelé",
      watcher: "Filtrovat podle sledujících",
      allWatchers: "Všichni sledující",
      project: "Filtrovat podle projektu",
      allProjects: "Všechny projekty",
      noProjects: "Žádné projekty",
      environment: "Filtrovat podle prostředí",
      allEnvironments: "Všechna prostředí",
      onDev: "Na devu",
      onTest: "Na testu",
      onProduction: "Na produkci",
      notDeployed: "Nenasazeno",
      release: "Filtrovat podle releasu",
      allReleases: "Všechny releasy",
      noRelease: "Bez releasu",
      scope: "Filtrovat podle rozsahu",
      defaultScope: "Výchozí rozsah",
      openOnly: "Jen otevřené",
      includeClosed: "Včetně uzavřených",
      attachments: "Filtrovat podle příloh",
      anyAttachments: "Libovolné přílohy",
      withAttachments: "S přílohami",
    },
    similar: {
      one: "Podobný tiket už existuje",
      other: "Podobných tiketů už existuje: {{count}}",
    },
    dialog: {
      title: "Nový tiket: {{type}}",
      project: "Projekt",
      selectProject: "— vyberte projekt —",
      noProjects: "Žádné projekty",
      initialState: "Počáteční stav",
      stateNew: "Nový (výchozí)",
      stateEstimation: "Odhad (vyžaduje řešitele)",
      stateApproving: "Schvalování (vyžaduje odhad)",
      priority: "Priorita",
      assignee: "Řešitel",
      pickProject: "Vyberte projekt…",
      loading: "Načítání…",
      defaultTeam: "— výchozí tým (vyvíjí Metoděj) —",
      noMembers: "Žádní členové projektu",
      targetRelease: "Cílový release",
      none: "— žádný —",
      noReleases: "Žádné releasy",
      titleLabel: "Název",
      titlePlaceholder: "Název: {{type}}",
      description: "Popis",
      descriptionPlaceholder: "Popište požadavek ({{type}})…",
      estimatedHours: "Odhadované hodiny",
      dueDate: "Termín",
      cancel: "Zrušit",
      saveAndOpen: "Uložit a otevřít detail",
      save: "Uložit",
      pickProjectFirst: "Nejdřív vyberte projekt",
      titleRequired: "Název je povinný",
      created: "Vytvořeno: {{type}}",
      createFailed: "Tiket se nepodařilo vytvořit",
      requestFailed: "Požadavek selhal",
    },
    newButton: "Nový: {{type}}",
  },
  workItemLabels: {
    type: {
      feature: "Funkce",
      bug: "Chyba",
      task: "Úkol",
      hotfix: "Hotfix",
    },
    typeBadge: {
      feature: "FUNKCE",
      bug: "CHYBA",
      task: "ÚKOL",
      hotfix: "HOTFIX",
    },
    priority: {
      low: "Nízká",
      normal: "Normální",
      high: "Vysoká",
      urgent: "Urgentní",
    },
    state: {
      new: "nový",
      estimation: "odhad",
      approving: "schvalování",
      in_progress: "rozpracováno",
      client_review: "kontrola klientem",
      done: "hotovo",
      blocked: "blokováno",
      waiting_on_client: "čeká na klienta",
      cancelled: "zrušeno",
      triage: "třídění",
      waiting_on_dependency: "čeká na jiný tiket",
      spec_drafting: "tvorba specifikace",
      spec_client_review: "schválení specifikace",
      merge_to_dev: "sloučení do devu",
      merge_to_test: "sloučení do testu",
      merge_to_main: "sloučení do produkce",
      internal_test_dev: "interní testování na devu",
      client_test_dev: "testování klientem na devu",
      internal_test_test: "interní testování na testu",
      client_test_test: "testování klientem na testu",
      internal_test_main: "interní testování na produkci",
      client_test_main: "testování klientem na produkci",
      dev_review: "nasazení na dev",
      ready_for_test: "nasazení na test",
      testing_on_test: "testování na testu",
      release_queue: "ve frontě na release",
    },
    releaseStatus: {
      open: "otevřený",
      locked: "zamčený",
      closed: "uzavřený",
    },
  },
  ui: {
    close: "Zavřít",
    clear: "Vymazat",
    clearSelection: "Zrušit výběr",
    search: "Hledat…",
    loading: "Načítání…",
    noMatches: "Nic nenalezeno",
    selectPlaceholder: "— vyberte —",
    selectAll: "Vybrat vše",
    noRecords: "Zatím žádné záznamy.",
    previousMonth: "Předchozí měsíc",
    nextMonth: "Další měsíc",
    openCalendar: "Otevřít kalendář",
    dateRange: {
      allTime: "Celé období",
      previous: "Předchozí období",
      next: "Další období",
      presets: {
        today: "Dnes",
        yesterday: "Včera",
        thisWeek: "Tento týden",
        lastWeek: "Minulý týden",
        pastTwoWeeks: "Poslední dva týdny",
        thisMonth: "Tento měsíc",
        lastMonth: "Minulý měsíc",
        thisYear: "Tento rok",
        lastYear: "Minulý rok",
      },
    },
    time: "Čas",
    timeHhmm: "Čas (hh:mm)",
    rowsPerPage: "Řádků na stránku",
    rows: "Řádků",
    previousPage: "Předchozí stránka",
    nextPage: "Další stránka",
    page: "Stránka {{page}}",
    showing: "Zobrazeno <1>{{from}}–{{to}}</1> z <1>{{total}}</1>",
  },
};
